export const SILENCED_RULES = 'SILENCED_RULES';
export const OPEN_SILENCE_MODAL = 'OPEN_SILENCE_MODAL';
export const CLOSE_SILENCE_MODAL = 'CLOSE_SILENCE_MODAL';
export const SHOW_SILENCED_ALERTS = 'SHOW_SILENCED_ALERTS';
export const EDIT_RULE = 'EDIT_RULE';
export const SELECT_SILENCE_RULE = 'SELECT_SILENCE_RULE';
export const DESELECT_SILENCE_RULE = 'DESELECT_SILENCE_RULE';
export const CLEAR_SELECTED_SILENCE_RULES = 'CLEAR_SELECTED_SILENCE_RULES'
